import { RouteConfig, RouteRegistry } from "../types";

export const sortRoutesBySpecificity = (routes: RouteRegistry): RouteRegistry => {
  const isRoot = (path: string) => path === "/";

  const prioritizeRoot = (a: RouteConfig, b: RouteConfig) =>
    isRoot(a.path) ? -1 : isRoot(b.path) ? 1 : 0;

  const getScore = (path: string = "") =>
    path
      .split("/")
      .filter(Boolean)
      .reduce((score, segment) => score + (segment.startsWith(":") ? 2 : 1), 0);

  const sortedRoutes = Object.entries(routes).sort(([_keyA, routeA], [_keyB, routeB]) => {
    const rootOrder = prioritizeRoot(routeA, routeB);
    if (rootOrder !== 0) return rootOrder;

    return getScore(routeB.path) - getScore(routeA.path);
  });

  return Object.fromEntries(sortedRoutes);
};
